import React from 'react'
import HeaderSevenOnepage from "../components/header/HeaderSevenOnepage";
import BannerSeven from "../components/banner/BannerSeven";
import BusinessGoalFour from "../components/businessgoal/BusinessGoalFour";
import AboutFive from "../components/about/AboutFive";
import TestimonialSix from "../components/testimonials/TestimonialSix";
import WorkingProcessFour from "../components/workingprocess/WorkingProcessFour";
import Video from "../components/video/Video";
import TeamFive from "../components/team/TeamFive";
import BusinessFive from "../components/businesscase/BusinessFive";
import CallToActionSix from "../components/calltoaction/CallToActionSix";
import TestimonialSeven from "../components/testimonials/TestimonialSeven";
import CaseSix from "../components/businesscase/CaseSix";
import BlogSeven from "../components/blog/BlogSeven";






import FooterOne from "../components/footer/FooterOne";

function HomeOne() {
    return (
        <div className='index-seven hr'>

            <HeaderSevenOnepage />
            <BannerSeven />
            <BusinessGoalFour />
            <AboutFive />
            <TestimonialSix />
            <WorkingProcessFour />
            <Video />
            <TeamFive />
            <BusinessFive />
            <CallToActionSix />
            <TestimonialSeven />
            <CaseSix />
            <BlogSeven />



            <FooterOne />

        </div>
    )
}

export default HomeOne